import React from 'react';

//Import styleshhet
import './loader.scss';

const Loader = () => {
  return (

    // https://www.w3schools.com/howto/howto_css_loader.asp
    <div className='myspinner' >
      <div className="loader"></div>
    </div>
  )
}

export default Loader